// extracted by mini-css-extract-plugin
export default {"close":"Close_close__+MFGW","white":"Close_white__TBap9","miblack":"Close_miblack__pSGft","miwhite":"Close_miwhite__sQuBP"};